import { createContext } from "react";
export var GlobalContext = createContext({});
